import React from 'react';
import { Main } from './components';

export const PackingV2: React.FC = () => {
    return <Main />;
}; 